import { DateRangeSchema } from 'cms/schemaTypes/generalSchemas/dateRange'
import { DocumentSchema } from 'cms/schemaTypes/generalSchemas/documents'

import { formatDateRange } from 'shared/utils/date'
import { PATHS } from 'shared/utils/paths'

import Paragraph from './Paragraph'
import { Section } from './Section'
import { SectionContainer } from './SectionContainer'
import SectionTitle from './SectionTitle'

import styles from './RewardsProgramCampaignSectionInfo.module.scss'

interface RewardsProgramCampaignSectionInfoProps {
  dateRange: DateRangeSchema
  document?: DocumentSchema
}
const RewardsProgramCampaignSectionInfo = ({
  dateRange,
  document
}: RewardsProgramCampaignSectionInfoProps) => {
  const { from, to } = dateRange
  const documentPath = PATHS.documents.replace(
    '[slug]',
    document?.slug?.current || ''
  )

  return (
    <Section $padding='medium'>
      <SectionContainer>
        <SectionTitle>Czas trwania akcji</SectionTitle>
        <div className={styles.paragraphWrapper}>
          <Paragraph>
            Akcja „... bo Twój wybór ma znaczenie!” trwa w dniach{' '}
            <strong>{formatDateRange(from || '', to || '')} r.</strong>
            <br />
            Prezenty zostaną przekazane do opłaconego zamówienia, odpowiednio{' '}
            <strong>
              <span className={styles.noWrap}>3, 5 oraz 7.</span>
            </strong>{' '}
            <strong>Liczba nagród jest ograniczona.</strong>
          </Paragraph>
          <div className={styles.linkWrapper}>
            {document?.slug?.current && (
              <a
                className={styles.linkToRules}
                href={documentPath}
                target='_blank'
              >
                <span>REGULAMIN AKCJI</span> <span>{`>`}</span>
              </a>
            )}
          </div>
        </div>
      </SectionContainer>
    </Section>
  )
}

export default RewardsProgramCampaignSectionInfo
